/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useMemo } from "react";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { MenuData, MenuItemType } from "web/types/Menu";

const useCategoryIds = (menu: MenuData) =>
  useMemo(() => {
    const idsMemo = isArrayHasItems(menu)
      ? menu.reduce<number[]>((result, current) => {
          switch (current?.type) {
            case MenuItemType.URL_CATEGORY: {
              const id = +current.id_category;
              return id ? [...result, id] : result;
            }
            case MenuItemType.SUBCATEGORIES:
            case MenuItemType.TILES: {
              // @ts-ignore
              const subCategoriesIds: number[] = isArrayHasItems(
                current.submenu
              )
                ? // @ts-ignore
                  current.submenu.reduce((subResult, subCurrent) => {
                    return subCurrent &&
                      subCurrent.type === "category" &&
                      +subCurrent.id_category
                      ? [...subResult, +subCurrent.id_category]
                      : subResult;
                  }, [])
                : [];
              return [...result, ...subCategoriesIds];
            }
            case MenuItemType.CATEGORY_FUNCTIONALITY: {
              const categoryId = +current?.functionality_id_category;
              return categoryId ? [...result, categoryId] : result;
            }
            default: {
              return result;
            }
          }
        }, [])
      : null;

    return Array.from(new Set(idsMemo));
  }, [menu]);

export default useCategoryIds;
